import { IEntity } from '@messaia/cdk';

export class ChangePassword implements IEntity {
	id: number;
	password: string;
	confirmPassword: string;
}